import React, { Component } from 'react';
import { Input } from '@driftt/tide-core'
import { fetchAppRedirectUrl, getAppAuthorization } from 'api/developerApi'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { showTransientNotification } from '@driftt/traffic-control'
import config from 'config'
import './style.css'

class AppOauthView extends Component {

  static propTypes = {
    appId: PropTypes.string.isRequired,
    showErrorNotification: PropTypes.func.isRequired
  }

  state = {
    clientId: '',
    redirectUrl: '',
    isFetchingCredentials: true,
    isFetchingUrl: true
  }

  fetchRedirectUrl = () => {
    const onSuccess = (redirectUrl) => this.setState({ redirectUrl })
    const onError = (error) => this.props.showErrorNotification('We couldn’t fetch your redirect URL. Please refresh the page.')
    const onFinally = () => this.setState({ isFetchingUrl: false })

    const onStateSet = () => fetchAppRedirectUrl(this.props.appId)
      .then(onSuccess)
      .catch(onError)
      .then(onFinally)

    this.setState({ isFetchingUrl: true }, onStateSet)
  }


  fetchCredentials = () => {
    const onDone = ({ clientId }) => {
      this.setState({ clientId })
    }

    const onError = (error) => {
      this.props.showErrorNotification('Ooops, something went wrong. Please refresh the page.')
    }

    const onFinally = () => {
      this.setState({ isFetchingCredentials: false })
    }

    const onStateSet = () => {
      getAppAuthorization(this.props.appId)
        .then(onDone)
        .catch(onError)
        .then(onFinally)
    }

    this.setState({ isFetchingCredentials: true }, onStateSet)
  }

  componentWillMount() {
    this.fetchRedirectUrl()
    this.fetchCredentials()
  }

  render() {
    const { clientId, redirectUrl } = this.state

    let authUrl = ''
    if (clientId && redirectUrl) {
      authUrl = `${config.DEVDRIFT_API_URL}/authorize?response_type=code&client_id=${clientId}&redirect_uri=${redirectUrl}&state=YOUR_STATE_VALUE`
    }

    return (
      <div className="oauth-url-view">
        <div className="oauth-url-view-page-title">
          Authorization URL 
        </div>
        <p className="oauth-url-view-page-description">
          This is your app&#39;s Oauth URL. You can this URL for external authenticatation requests for users to authorize your Drift App.
          The state value in the url can be replaced with the value of your choosing.
        </p>
        <div>
          <Input
            className="oauth-url-input"
            value={authUrl}
            readOnly
          />
        </div>
      </div>
    )
  }
}


const mapStateToProps = null
const mapDispatchToProps = dispatch => ({
  showErrorNotification: (message) => dispatch(showTransientNotification({ type: 'error', message }))
})

export default connect(mapStateToProps, mapDispatchToProps)(AppOauthView)